module.exports = __webpack_public_path__ + "img/2.c8f8f030.png";